export const siteCountyOptions = [
  {
    name: '不篩選',
    value: []
  },
  {
    name: '北區',
    value: ['花蓮縣', '宜蘭縣', '台北市', '桃園市', '新竹縣']
  },
  {
    name: '中區',
    value: ['苗栗縣', '台中市', '彰化縣', '南投縣', '雲林縣']
  },
  {
    name: '南區',
    value: [
      '嘉義縣',
      '台南市',
      '高雄市',
      '屏東縣',
      '台東市',
      '金門縣',
      '澎湖縣'
    ]
  }
].map((item) => ({
  text: item.name,
  value: item.value
}))
